/* eslint-disable max-len */
import {pathWithParams, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {sucessCustom} from '@/utils/successHandling';
import {useAxios} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const servicio = 'Configuracion';
// #endregion

async function postFilterConfiguracion(_datafilter) {
  const url = `${pathWithParams()}${servicio}/Filter?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _datafilter, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getConfiguracionId(_id) {
  const url = `${pathWithParams()}${servicio}/${_id}?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function postAddConfiguracion(_data) {
  const url = `${pathWithParams()}${servicio}?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _data, {timeout: DEFAULT_TIMEOUT});
    sucessCustom(response.message);
    return response.success;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}
async function getValorConfiguracionByClave(_clave) {
  const url = `${pathWithParams()}${servicio}/GetValorConfiguracionByClave/${_clave}?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  postFilterConfiguracion,
  getConfiguracionId,
  postAddConfiguracion,
  getValorConfiguracionByClave,
};
